import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  container: {
    backgroundColor: theme.palette.common.white,
    margin: '0 0 24px 0',
    borderRadius: 18,
    border: '1px solid rgba(16,24,40,0.07)',
    boxShadow:
      'inset 0 1px 0 rgba(255,255,255,0.9), 0 1px 2px rgba(16,24,40,0.06), 0 10px 28px -12px rgba(16,24,40,0.18)',
    backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, #FBFBFC 100%)',
    textAlign: 'left',
    overflow: 'hidden',
    paddingBottom: 0
  },
  // Fills whatever holds it: the modal card sets the width and centres it.
  width60: {
    width: '100%'
  },
  heading: {
    backgroundColor: theme.palette.common.white,
    backgroundImage:
      'linear-gradient(180deg, rgba(255,241,233,0.75) 0%, rgba(255,255,255,0) 100%)',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px 16px 0 0',
    textAlign: 'left'
  },
  headingBlack: {
    backgroundColor: theme.palette.common.white,
    backgroundImage:
      'linear-gradient(180deg, rgba(255,241,233,0.75) 0%, rgba(255,255,255,0) 100%)',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px 16px 0 0',
    textAlign: 'left'
  },
  form: {
    margin: '4px 24px 24px 24px',
    alignItems: 'stretch',
    textAlign: 'left'
  },
  text: {
    color: theme.palette.text.primary,
    fontSize: 16,
    fontWeight: 700
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    minHeight: 38,
    borderRadius: 10,
    color: theme.palette.common.white,
    fontWeight: 600,
    textTransform: 'none',
    border: 'none',
    boxShadow: 'none',
    margin: '20px 0 20px 0',
    '&:hover': {
      backgroundColor: theme.palette.primary.main3,
      color: theme.palette.common.white
    }
  },
  labelText: {
    textAlign: 'left',
    marginLeft: 0,
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.text.disabled,
    marginTop: '16px'
  }
}))

export default useStyles
